<template>
  <form-builder-editor-field
    :item="item"
    v-on="$listeners"
  >
    <div class="form-group">
      <label>Size</label>
      <select v-model="item.size" class="form-control">
        <option v-for="(head, index) in headings"
                :key="'input-type-size-' + index" :value="head.value">
          {{ head.label }}
        </option>
      </select>
    </div>

  </form-builder-editor-field>
</template>

<script>
import FormBuilderEditorField from "./FormBuilderEditorField";

export default {
  components: {FormBuilderEditorField},

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  setup() {
    const headings = [{
        label: "H1",
        value: "h1"
      }, {
        label: "H2",
        value: "h2"
      }, {
        label: "H3",
        value: "h3"
      }, {
        label: "H4",
        value: "h4"
      }, {
        label: "H5",
        value: "h5"
      }, {
        label: "H6",
        value: "h6"
      }
    ]

    return {
      headings
    }
  }
}
</script>



// WEBPACK FOOTER //
// FormBuilderEditorHeader.vue?28a28e14